import React, { memo } from "react";
import classnames from "classnames";
import { Element, POSITION } from "src/components/base";
import { twMerge } from "tailwind-merge";

interface IProps {
    className?: string;
    children: React.ReactNode;
    align?: POSITION;
    domRef?: any;
}

function LevelSide(props: IProps) {
    const { className, children, align, ...rest } = props;
    return (
        <Element
            {...rest}
            className={twMerge(
                classnames({
                    ["level-left flex basis-auto grow-0 shrink-0 items-center justify-start"]:
                        align === "left",
                    ["level-right flex basis-auto grow-0 shrink-0 items-center justify-end"]:
                        align === "right",
                }),
                className
            )}
        >
            {children}
        </Element>
    );
}

export default memo(LevelSide);
